import { useState, useRef, Fragment } from "react";
import { put, post } from "util/requests";
import styles from "../crf_builder.module.css";
import { Checkbox, TextField, Select } from "@mui/material";
import { cloneDeep } from "lodash";
import EditableText from "./editable_text";
import DeleteIcon from "@mui/icons-material/Delete";
import Radio from "@mui/material/Radio";
import MenuItem from "@mui/material/MenuItem";

export default function Selections(props) {
  const { field, setMainCrfOptions, updateField, fieldArray, setRegionModalisOpenData, regions } = props;
  // const [options, setOptions] = useState(field.options || []);
  const options = field.options;
  const onKeyDown = (key) => {
    if (key.keyCode === 13) {
      key.target.blur();
    }
  };

  const modifyOptionLabel = (index, value) => {
    let opt = cloneDeep(options);
    if (field.versioning_field) {
      if (opt.constructor === Object) {
        opt[field.active_version_string][index].label = value;
      } else {
        opt[field.active_version_string] = [{ label: value }];
      }
    } else {
      opt[index].label = value;
    }

    // setOptions(opt);
    setMainCrfOptions(field.id, opt);
  };

  const modifyOptionValue = (index, value) => {
    let opt = cloneDeep(options);
    if (field.versioning_field) {
      if (opt.constructor === Object) {
        opt[field.active_version_string][index].value = value;
      } else {
        opt[field.active_version_string] = [{ value }];
      }
    } else {
      opt[index].value = value;
    }

    // setOptions(opt);
    setMainCrfOptions(field.id, opt);
  };

  const modifyScoreValue = (index, value) => {
    let opt = cloneDeep(options);
    opt[index].score = value;
    // setOptions(opt);
    setMainCrfOptions(field.id, opt);
  };

  const modifyOptionFreeText = (index, value) => {
    // let opt = cloneDeep(options);
    let opt = options;
    opt[index].free_text = value;
    // setOptions(opt);
    setMainCrfOptions(field.id, opt);
  };

  const setUnits = (units) => {
    let _field = cloneDeep(field);
    _field.units = units;
    updateField(_field.id, _field);
  };

  const setMaxLength = (length) => {
    let _field = cloneDeep(field);
    _field.max_length = length;
    updateField(_field.id, _field);
  };

  const setMultiline = (multiline) => {
    let _field = cloneDeep(field);
    _field.multiline = multiline;
    updateField(_field.id, _field);
  };
  const setSuggestionsCheckbox = (suggestions_enabled) => {
    let _field = cloneDeep(field);
    _field.suggestions_enabled = suggestions_enabled;
    updateField(_field.id, _field);
  };
  const setSuggestions = (suggestions) => {
    let _field = cloneDeep(field);
    _field.suggestions = suggestions;
    updateField(_field.id, _field);
  };

  const setPlaceHolder = (placeHolder) => {
    let _field = cloneDeep(field);
    _field.placeHolder = placeHolder;
    updateField(_field.id, _field);
  };

  const setWholeLength = (length) => {
    let _field = cloneDeep(field);
    _field.whole_length = parseInt(length);
    updateField(_field.id, _field);
  };

  const setDecimalLength = (length) => {
    let _field = cloneDeep(field);
    _field.decimal_length = parseInt(length);
    updateField(_field.id, _field);
  };

  const setFieldValue = (key, value) => {
    let _field = cloneDeep(field);
    _field[key] = value;
    updateField(_field.id, _field);
  };

  const addOptionField = () => {
    let opt = cloneDeep(options);
    if (field.versioning_field) {
      if (opt.constructor === Object) {
        if (opt[field.active_version_string]) {
          opt[field.active_version_string].push({ label: "", value: "" });
        } else {
          opt[field.active_version_string] = [{ label: "", value: "" }];
        }
      } else {
        opt = { [field.active_version_string]: [{ label: "", value: "" }] };
      }
    } else {
      opt.push({ label: "", value: "" });
    }
    setMainCrfOptions(field.id, opt);
  };

  const deleteOption = (index) => {
    let opt = cloneDeep(options);
    opt.splice(index, 1);
    // setOptions(opt);
    setMainCrfOptions(field.id, opt);
  };

  const optionsYesNo = () => {
    let opt = [
      { label: "Yes", value: "yes" },
      { label: "No", value: "no" },
    ];
    // setOptions(opt);
    setMainCrfOptions(field.id, opt);
  };

  const handleBloodTestResultData = (key, value) => {
    const _field = cloneDeep(field);
    if (!_field.options || !(_field.options.constructor === Object)) {
      _field.options = {};
    }
    if (key === "is_available") {
      _field.options.is_available = value ? true : false;
    } else if (key === "int") {
      _field.options.int_value = value ? {} : null;
    } else if (key === "decimal") {
      _field.options.decimal_value = value ? {} : null;
    } else if (key === "units") {
      if (value) {
        _field.options.units_value = [{}, {}];
      } else {
        delete _field.options.units_value;
      }
    }
    updateField(_field.id, _field);
  };

  const setBloodTestResultDataUnits = (id, label_or_value, text) => {
    const _field = cloneDeep(field);
    _field.options.units_value[id][label_or_value] = text;
    updateField(_field.id, _field);
  };

  const handleBloodTestResultIntMetaData = (key, value) => {
    const _field = cloneDeep(field);
    if (!_field.options.int_value) {
      _field.options.int_value = {};
    }
    if (key === "max_length") {
      _field.options.int_value.max_length = value;
    } else if (key === "units") {
      _field.options.int_value.units = value;
    }
    updateField(_field.id, _field);
  };

  const handleBloodTestResultDecimalMetaData = (key, value) => {
    const _field = cloneDeep(field);
    if (!_field.options.decimal_value) {
      _field.options.decimal_value = {};
    }
    if (key === "whole_length") {
      _field.options.decimal_value.whole_length = parseInt(value);
    } else if (key === "decimal_length") {
      _field.options.decimal_value.decimal_length = parseInt(value);
    } else if (key === "units") {
      _field.options.decimal_value.units = value;
    }
    updateField(_field.id, _field);
  };

  const sx = {
    marginLeft: "4px",
    marginTop: "10px",
    "& .MuiInputBase-input": {
      width: "auto",
      minWidth: "140px",
      maxWidth: "300px",

      fieldSizing: "content",
    },
  };

  const sx_score = {
    marginLeft: "4px",
    marginTop: "10px",
    "& .MuiInputBase-input": {
      width: "auto",
      minWidth: "80px",
      maxWidth: "160px",

      fieldSizing: "content",
    },
  };

  if (["radio", "select", "drop_down"].includes(field.type)) {
    return (
      <div>
        <div className={styles.options_row_wrapper}>
          {field.versioning_field ? (
            <Select
              value={field.active_version_string || ""}
              sx={{
                fontSize: 14,
                minWidth: 200,
                height: 30,
                padding: 0,
                alignSelf: "center",
              }}
              onChange={(e) => setFieldValue("active_version_string", e.target.value)}
            >
              {fieldArray
                .find((f) => parseInt(f.id) === parseInt(field.versioning_field_id))
                ?.options?.map((f) => (
                  <MenuItem key={f.value} value={f.value}>
                    {f.label}
                  </MenuItem>
                ))}
            </Select>
          ) : null}
          {(field?.active_version_string ? options[field.active_version_string] || [] : options).map(
            (option, index) => {
              return (
                <div className={styles.options_row} key={`${index}`}>
                  <TextField
                    value={option.label || ""}
                    label="label"
                    type="text"
                    size="small"
                    onChange={(e) => modifyOptionLabel(index, e.target.value)}
                    sx={sx}
                    onKeyDown={onKeyDown}
                  />
                  <TextField
                    value={option.value || ""}
                    label="value"
                    type="text"
                    size="small"
                    onChange={(e) => modifyOptionValue(index, e.target.value)}
                    sx={sx}
                    onKeyDown={onKeyDown}
                  />
                  {field.calculated_source ? (
                    <TextField
                      value={option.score || ""}
                      label="score"
                      type="text"
                      size="small"
                      onChange={(e) => modifyScoreValue(index, e.target.value)}
                      sx={sx_score}
                      onKeyDown={onKeyDown}
                    />
                  ) : null}
                  {field.enable_free_text && (
                    <div className={styles.flex_row}>
                      <Radio
                        size="small"
                        checked={option.free_text || false}
                        sx={{
                          padding: "0px",
                          marginRight: "6px",
                          marginLeft: "10px",
                        }}
                        onChange={(e) => {
                          for (let i = 0; i < options.length; i++) {
                            modifyOptionFreeText(i, "");
                          }
                          modifyOptionFreeText(index, e.target.checked);
                        }}
                        onClick={(e) => {
                          if (option.free_text) {
                            modifyOptionFreeText(index, "");
                          }
                        }}
                      />

                      <div>Free Text</div>
                    </div>
                  )}
                  {field.type === "drop_down" && (
                    <div className={styles.flex}>
                      <div
                        className={styles.add_button}
                        onClick={() =>
                          setRegionModalisOpenData({
                            id: field.id,
                            source: "option",
                            option_index: index,
                            activeRegions: field.options[index]?.regions || [],
                          })
                        }
                      >
                        regions
                      </div>
                      {option.regions
                        ?.map((id) => {
                          return regions.find((r) => r.id === id)?.code || null;
                        })
                        .filter((i) => i)
                        .join(",") || "all"}
                    </div>
                  )}
                  <div onClick={() => deleteOption(index)} className={styles.delete_button}>
                    <DeleteIcon
                      className={styles.table_action_icon}
                      onClick={() => {}}
                      sx={{ fontSize: 18, color: "#e66767" }}
                    />
                  </div>
                </div>
              );
            }
          )}
        </div>
        <div className={styles.add_option_row}>
          <div onClick={addOptionField} className={styles.add_button}>
            Add Option
          </div>
          {["radio", "blood_test_result"].includes(field.type) && (
            <div onClick={optionsYesNo} className={styles.add_button}>
              Yes/No Default
            </div>
          )}
          <div className={styles.inline_flex}>
            <Checkbox
              size="small"
              checked={field.enable_free_text || false}
              sx={{
                padding: "0px",
                marginRight: "6px",
                marginLeft: "10px",
              }}
              onChange={(e) => {
                setFieldValue("enable_free_text", e.target.checked);
              }}
            />{" "}
            <div>Enable Free Text</div>
          </div>
        </div>
      </div>
    );
  } else if (field.type === "int") {
    return (
      <div className={styles.options_row}>
        <div>
          <div>Units</div>
          <div>
            <EditableText
              text={(field && field.units) || "unit_placeholder"}
              onChange={(value) => setUnits(value)}
              width={100}
            />
          </div>
        </div>
        <div className={styles.vertical_meta_option}>
          <div>MaxLength</div>
          <div>
            <EditableText
              text={(field && field.max_length) || "length_placeholder"}
              onChange={(value) => setMaxLength(value)}
              width={100}
            />
          </div>
        </div>
      </div>
    );
  } else if (field.type === "text") {
    return (
      <div>
        <div className={styles.flex_row}>
          <div>
            <Checkbox checked={field && field.multiline} onChange={(e) => setMultiline(e.target.checked)} />
          </div>
          <div>Multiline</div>
        </div>
        <div className={styles.flex_row}>
          <div>
            <Checkbox
              checked={field && field.suggestions_enabled}
              onChange={(e) => setSuggestionsCheckbox(e.target.checked)}
            />
          </div>
          <div>Entry Suggestions:</div>
          {field.suggestions_enabled ? (
            <div>
              <EditableText
                text={field && field.suggestions}
                placeholder={"suggestions"}
                onChange={(value) => setSuggestions(value)}
                width={200}
              />
            </div>
          ) : null}
        </div>
        <div className={styles.flex_row}>
          <div>Placeholder:</div>
          <div>
            <EditableText
              text={(field && field.placeHolder) || ""}
              placeholder={"placeHolder"}
              onChange={(value) => setPlaceHolder(value)}
              width={200}
            />
          </div>
        </div>
      </div>
    );
  } else if (field.type === "decimal") {
    return (
      <div className={styles.options_row}>
        <div>
          <div>Units</div>
          <div>
            <EditableText
              text={(field && field.units) || "unit_placeholder"}
              onChange={(value) => setUnits(value)}
              width={100}
            />
          </div>
        </div>
        <div className={styles.vertical_meta_option}>
          <div>Whole Length</div>
          <div>
            <EditableText
              text={(field && field.whole_length) || "length_placeholder"}
              onChange={(value) => setWholeLength(value)}
              width={100}
            />
          </div>
        </div>
        <div className={styles.vertical_meta_option}>
          <div>Decimal Length</div>
          <div>
            <EditableText
              text={(field && field.decimal_length) || "decimal_length"}
              onChange={(value) => setDecimalLength(value)}
              width={100}
            />
          </div>
        </div>
      </div>
    );
  } else if (field.type === "blood_test_result") {
    return (
      <div>
        <div className={styles.options_row}>
          <Checkbox
            checked={field.options && field.options.is_available}
            onChange={(e) => {
              handleBloodTestResultData("is_available", e.target.checked);
            }}
          />
          result available yes/no
        </div>
        <div className={styles.options_row}>
          <div>
            <Checkbox
              checked={field.options && field.options.int_value}
              onChange={(e) => {
                handleBloodTestResultData("int", e.target.checked);
              }}
            />
            int value
          </div>
          <div className={styles.vertical_meta_option}>
            <div>MaxLength</div>
            <div>
              <EditableText
                text={
                  (field && field.options && field.options.int_value && field.options.int_value.max_length) ||
                  "length_placeholder"
                }
                onChange={(value) => handleBloodTestResultIntMetaData("max_length", value)}
                width={100}
              />
            </div>
          </div>
          <div>
            <div>Units</div>
            <EditableText
              text={(field.options && field.options.int_value && field.options.int_value.units) || "unit_placeholder"}
              onChange={(value) => handleBloodTestResultIntMetaData("units", value)}
              width={100}
            />
          </div>
        </div>
        <div className={styles.options_row}>
          <div>
            <Checkbox
              checked={field.options && field.options.decimal_value}
              onChange={(e) => {
                handleBloodTestResultData("decimal", e.target.checked);
              }}
            />
            decimal value
          </div>
          <div>
            <div>Units</div>
            <EditableText
              text={
                (field.options && field.options.decimal_value && field.options.decimal_value.units) ||
                "unit_placeholder"
              }
              onChange={(value) => handleBloodTestResultDecimalMetaData("units", value)}
              width={100}
            />
          </div>
          <div>
            <div>Whole Length</div>
            <EditableText
              text={
                (field.options && field.options.decimal_value && field.options.decimal_value.whole_length) ||
                "whole_length"
              }
              onChange={(value) => handleBloodTestResultDecimalMetaData("whole_length", value)}
              width={100}
            />
          </div>
          <div>
            <div>Decimal Length</div>
            <EditableText
              text={
                (field.options && field.options.decimal_value && field.options.decimal_value.decimal_length) ||
                "decimal_length"
              }
              onChange={(value) => handleBloodTestResultDecimalMetaData("decimal_length", value)}
              width={100}
            />
          </div>
        </div>
        <div className={styles.options_row}>
          <div>
            <Checkbox
              checked={!!(field.options && field.options.units_value) || false}
              onChange={(e) => {
                handleBloodTestResultData("units", e.target.checked);
              }}
            />
            units display
          </div>
          <div>
            <EditableText
              text={
                (field.options && field.options.units_value && field.options && field.options.units_value[0].label) ||
                "unit1_label"
              }
              onChange={(value) => setBloodTestResultDataUnits(0, "label", value)}
              width={100}
            />
          </div>
          <div>
            <EditableText
              text={
                (field.options && field.options.units_value && field.options && field.options.units_value[0].value) ||
                "unit1_value"
              }
              onChange={(value) => setBloodTestResultDataUnits(0, "value", value)}
              width={100}
            />
          </div>
          <div>
            <EditableText
              text={
                (field.options && field.options.units_value && field.options && field.options.units_value[1].label) ||
                "unit2_label"
              }
              onChange={(value) => setBloodTestResultDataUnits(1, "label", value)}
              width={100}
            />
          </div>
          <div>
            <EditableText
              text={
                (field.options && field.options.units_value && field.options && field.options.units_value[1].value) ||
                "unit2_value"
              }
              onChange={(value) => setBloodTestResultDataUnits(1, "value", value)}
              width={100}
            />
          </div>
        </div>
      </div>
    );
  } else return null;
}
